import React, { useState, useEffect } from 'react';
import { getSiteSettings } from '../services/api';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

export const THRONE_DEFAULTS = {
  enabled: true,
  url: '',
  title: '',
  blurb: 'Feeling generous? You can spoil us through Throne! 💕 Gifts are never expected, but always appreciated—and your support means the world to us.',
  logoImage: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_2ecf2c04-cfc8-4dfd-a29b-95bcebd96487/artifacts/kzowafy3_Throne.me_invert_logo.webp'
};

export const useThroneLink = () => {
  const [link, setLink] = useState(null);

  useEffect(() => {
    let mounted = true;
    getSiteSettings()
      .then((data) => {
        if (mounted) setLink({ ...THRONE_DEFAULTS, ...(data?.throneLink || {}) });
      })
      .catch(() => {
        if (mounted) setLink(THRONE_DEFAULTS);
      });
    return () => { mounted = false; };
  }, []);

  return link;
};

export const ThroneNavLink = () => {
  const link = useThroneLink();

  if (!link || !link.enabled) return null;

  const clickable = Boolean(link.url && link.url.trim());
  const Wrapper = clickable ? 'a' : 'span';
  const wrapperProps = clickable
    ? { href: link.url, target: '_blank', rel: 'noopener noreferrer' }
    : {};

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Wrapper
            {...wrapperProps}
            data-testid="throne-nav-link"
            className={`flex items-center flex-shrink-0 opacity-80 transition-opacity ${clickable ? 'cursor-pointer hover:opacity-100' : ''}`}
          >
            <img
              src={link.logoImage}
              alt="Throne"
              data-testid="throne-nav-logo"
              className="h-5 sm:h-6 w-auto max-w-[110px] object-contain"
            />
          </Wrapper>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          className="max-w-xs bg-gray-900 border border-purple-900/60 text-gray-200 font-typewriter text-xs leading-relaxed px-4 py-3"
          data-testid="throne-nav-tooltip"
        >
          {link.blurb}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ThroneNavLink;
